import styled from "styled-components";
import { COLOR_SECONDARY } from "../../common/styles/Colors";

export const StyledInput = styled.input`
  height: 40px;
  width: 100%;
  padding: 10px;
  color: #63636d;
  font-size: 16px;
  border: none;
  border-radius: 50px;
  outline-color: transparent;
  outline: none;
`;

export const Container = styled.div`
  margin: 0;
`;

export const Icon = styled.span`
  color: ${COLOR_SECONDARY};
  margin: 0 10px;
  font-size: 23px;
  margin-top: 5px;
`;

export const Input = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #bdc2ca;
  border-radius: 50px;
`;

export const Validation = styled.div`
  width: 100%;
  color: grey;
  font-size: 12px;
  line-height: auto;
  margin: 0;
  padding-left: 5px;
  margin-bottom: 1%;
  overflow: visible;
  white-space: wrap;
`;
